/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_New_PasswordInputs */

const cs_settings_users_new_password = /** @type {(inputs: Settings_Users_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nové heslo (volitelné)`)
};

const en_settings_users_new_password = /** @type {(inputs: Settings_Users_New_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New password (optional)`)
};

/**
* | output |
* | --- |
* | "New password (optional)" |
*
* @param {Settings_Users_New_PasswordInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_new_password = /** @type {((inputs?: Settings_Users_New_PasswordInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_New_PasswordInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_new_password(inputs)
	return cs_settings_users_new_password(inputs)
});